// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const BarchartIcon = createSvgIcon(
  <svg
    width={24}
    height={24}
    fill="currentColor"
    aria-hidden="true"
    viewBox="0 0 24 24"
  >
    <path d="M6.21 12H4.93C3.87 12 3 12.8 3 13.8v5.4c0 1 .87 1.8 1.93 1.8H6.2c1.07 0 1.93-.8 1.93-1.8v-5.4c0-1-.86-1.8-1.93-1.8m.65 7.2c0 .33-.3.6-.65.6H4.93c-.36 0-.64-.27-.64-.6v-5.4c0-.33.28-.6.64-.6H6.2c.36 0 .65.27.65.6zm5.78-10.8h-1.28c-1.07 0-1.93.8-1.93 1.8v9c0 1 .86 1.8 1.93 1.8h1.28c1.07 0 1.93-.8 1.93-1.8v-9c0-1-.86-1.8-1.93-1.8m.65 10.8c0 .33-.3.6-.65.6h-1.28c-.36 0-.65-.27-.65-.6v-9c0-.33.3-.6.65-.6h1.28c.36 0 .65.27.65.6zm5.78-15.6H17.8c-1.07 0-1.93.8-1.93 1.8v13.8c0 1 .86 1.8 1.93 1.8h1.28c1.06 0 1.93-.8 1.93-1.8V5.4c0-1-.87-1.8-1.93-1.8m.64 15.6c0 .33-.28.6-.64.6H17.8c-.36 0-.65-.27-.65-.6V5.4c0-.33.3-.6.65-.6h1.28c.36 0 .64.27.64.6zM3.1 9.3a.6.6 0 0 1 .23-.82l7.51-4.06-1.09-.24c-.34-.07-.56-.4-.48-.71.08-.33.43-.53.77-.45l2.66.57c.35.07.56.4.48.72l-.61 2.48a.64.64 0 0 1-.63.46l-.14-.01c-.35-.08-.56-.4-.48-.72l.27-1.12-7.62 4.12a1 1 0 0 1-.32.08.7.7 0 0 1-.55-.3" />
  </svg>,
  "Barchart",
);
export default BarchartIcon;
